module.exports = __webpack_public_path__ + "b93ae2966223a21832a02a2d39e22615.jpg";